import React, { useEffect, useState } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import { GoodsRequest } from '../../types/goods-response';
import WarehouseDetailView from '../Views/WarehouseManageView';
import { useDownloadFilesGoods, useDownloadPDFGoods, useFetchGoodsById } from '../../../../hooks';
import { useLocation, useManageGoodConsumerItems, useManageStatus, useManageStatusGoodItemPetition } from '../../../../share';
import { useGoodGestorItems } from '../../../../utils/validators/good-request/goodGestorUpdateValidator';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { GoodTypes } from '../../types';

interface GoodsDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  data?: GoodsRequest;
  isLoading?: boolean;
  refetch?: () => void;
  isApproveRequest?: boolean;
  id?: string;
}

const GoodsDetailContainer: React.FC<GoodsDetailProps> = ({
  isOpen,
  OnClose,
  data,
  isLoading,
  refetch,
  isApproveRequest,
  id,
}) => {
  const [idToDownloadFiles, setIdToDownloadFiles] = useState()
  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);
  const { mutateAsync } = useDownloadFilesGoods();
  const { mutateAsync: downloadPDF } = useDownloadPDFGoods();
  
  const { data: goodPetition } = useManageStatus('GoodPetition');
  const { data: goodPetitionItems } = useManageStatusGoodItemPetition();
  const { mutateAsync: manageItems } = useManageGoodConsumerItems();
  const { data: location = [], isLoading: isLoadingLocation } = useLocation();
  const [dataGood, setDataGood] = useState<GoodsRequest | undefined>();

  const { showToast } = useCustomToast();
  
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false)
  const [isResponseOk, setIsResponseOk] = useState(false)
  const [assetsList, setAssetsList] = useState<any[]>([]);
  const [messageAlert, setMessageAlert] = useState<string>('');

  const { data: detailData, isPending: isLoadingData, refetch: refetchId } =
    useFetchGoodsById(id);
  
  const onSaveManageItems = async (values: any) => {
    try {
      const body = {
        items: values.items.map((item: any) => ({
          ...item,
          id: item.id,
          itemable_id: item.itemable_id || item.id,
          location_id: item.location_id,
          quantity_received: item.quantity_received,
          quantity_requested: item.quantity_requested,
          consumer_good_branch_id: item.consumer_good_branch_id,
          manage_status_id: item.manage_status_id || 14, // No entregado
          observations: item.observations,
        })),
        reason: values.reason || 'Sin registro',
      };

      await manageItems({ body, id: dataGood?.id ?? 0 });

      showToast("success", "Solicitud gestionada correctamente")

      setIsResponseOk(true)
      setiIsOpenSaveChanges(false);
      if (refetch) {
        refetch();
      }
      if (refetchId) refetchId();
      closeAndReset()
    } catch (error) {
      setIsResponseOk(false)
      showToast("error", "Error al gestionar la solicitud")
    }
  };

  const formikSolicitud = useGoodGestorItems({ onSubmit: onSaveManageItems })

  const closeAndReset = () => {
    formikSolicitud.resetForm()
    OnClose()
  }
  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
  }

  const confirmSaveChanges = async () => {
    formikSolicitud.handleSubmit();
  };
  
  const handleSaveManageItems = async () => {
    const typeMovement = dataGood?.goods_type;
    const manageItems = formikSolicitud.values.items?.filter((item: any) => typeMovement === GoodTypes.ACTIVO_FIJO ? (!item.status_manage) : (!item.status_manage && !item.quantity_received));

    if (manageItems?.length > 0) {
      showToast('error', 'Debe gestionar los bienes antes de finalizar.');
      return;
    }

    if (dataGood?.goods_type === GoodTypes.BIEN_CONSUMO) {
      const validateMaxRequest = formikSolicitud.values.items?.filter((item: any) => item.quantity_received > item.quantity_requested);

      if (validateMaxRequest.length > 0) {
        showToast('error', 'Supero la cantidad solicitada.');
        return;
      }
    }
    const numItems = typeMovement === GoodTypes.ACTIVO_FIJO 
      ? (dataGood?.items?.length ?? 0) - (formikSolicitud.values.items?.length)
      : (dataGood?.items?.length ?? 0) - (formikSolicitud.values.items?.filter((item: any) => item.manage_status_id !== 14)?.length ?? 0);
    
    const message = numItems !== 0 ? `No ha gestionado ${numItems} elementos de la solicitud` : '';

    setMessageAlert(message)

    setiIsOpenSaveChanges(true);
  }

  useEffect(() => {
    if (detailData || data) {
      setDataGood(detailData || data);
    }
  }, [detailData, data]);

  return (
    <CustomModal
      title={`Detalle solicitud de bienes - ${dataGood?.ticket || '-'}`}
      open={isOpen}
      onCancel={closeAndReset}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      labelCancel={'Cancelar'}
      labelSubmit={'Finalizar'}
      onSave={handleSaveManageItems}
    >
      <WarehouseDetailView
        detailData={dataGood}
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        downloadFile={setIdToDownloadFiles}
        goodStates={goodPetition}
        goodPetitionItems={goodPetitionItems}
        setIsResponseOk={setIsResponseOk}
        formikSolicitud={formikSolicitud}
        isResponseOk={isResponseOk}
        isApproveRequest={isApproveRequest}
        assetsList={assetsList}
        setAssetsList={setAssetsList}
        location={location}
        onDownloadPDF={downloadPDF}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de gestionar esta solicitud de bienes?"
        textTwo='Recuerde que una vez el estado de la solicitud sea "por registrar" no podrá hacer cambios.'
        textThree={messageAlert}
        open={isOpenSaveChanges}
        width={1000}
        centered
        isLoadingSave={false}
        onClose={() => closeModalSaveChanges()}
        labelSubmit="Aceptar"
        onSave={() => confirmSaveChanges()}
      />
    </CustomModal>
  );
};

export default GoodsDetailContainer;
